import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
    private subject = new Subject<any>();
	private logoutsubject = new Subject<any>();
    private cartsubject = new Subject<any>();
    private paymentsubject = new Subject<any>();
    private restFootersubject = new Subject<any>();
    private vouchersubject = new Subject<any>();
    private whywechosesubject = new Subject<any>();
    private amountsubject = new Subject<any>();
	private autocompletesubject = new Subject<any>();
	private locationsubject = new Subject<any>();
	private authdatasubject = new Subject<any>();
	private addphotovideosubject = new Subject<any>();
    private addRegistryPopupToComponentsubject = new Subject<any>();
    private totalsubject = new Subject<any>();
    private requestsubject = new Subject<any>();
	private addgiftcertificate = new Subject<any>();
	private video_url = new Subject<any>();
	private notification_count = new Subject<any>();
	private photoUpdateSubject = new Subject<any>();
	private facebookDataSubject = new Subject<any>();
	private coupleStartTimerSubject = new Subject<any>();
    private getUrl: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private addTip = new Subject<any>();

    private createExpStepSubject: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    getUrlMessage(message:any) {
        this.getUrl.next( message );
    }
    getData(): BehaviorSubject<any> {
        return this.getUrl;
      }
    sendMessage(message: string) {
        this.subject.next( message );
    }
    clearMessage() {
        this.subject.next(true);
    }
    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
    sendConfirmRequestMessage(message: string) {
        this.requestsubject.next( message );
    }
    clearConfirmRequestMessage() {
        this.requestsubject.next(true);
    }
    getConfirmRequestMessage(): Observable<any> {
        return this.requestsubject.asObservable();
    }
    sendTotalMessage(message: any) {
        this.totalsubject.next( message );
    }
    clearTotalMessage() {
        this.totalsubject.next(true);
    }
    getTotalMessage(): Observable<any> {
        return this.totalsubject.asObservable();
    }
	
    sendLogoutMessage(message: string) {
        this.logoutsubject.next( message );
    }

    clearLogoutMessage() {
        this.logoutsubject.next(true);
    }

    getLogoutMessage(): Observable<any> {
        return this.logoutsubject.asObservable();
    }
    sendAmountMessage(message: string) {
        this.amountsubject.next( message );
    }

    clearAmountMessage() {
        this.amountsubject.next(true);
    }

    getAmountMessage(): Observable<any> {
        return this.amountsubject.asObservable();
    }

    sendWhyWeChoseMessage(message: string) {
        this.whywechosesubject.next( message );
    }

    clearWhyWeChoseMessage() {
        this.whywechosesubject.next(true);
    }

    getWhyWeChoseMessage(): Observable<any> {
        return this.whywechosesubject.asObservable();
    }

    sendVoucherMessage(message: string) {
        this.vouchersubject.next( message );
    }

    clearVoucherMessage() {
        this.vouchersubject.next(true);
    }

    getVoucherMessage(): Observable<any> {
        return this.vouchersubject.asObservable();
    }

    sendPaymentMessage(message: string) {
        this.paymentsubject.next( message );
    }

    clearPaymentMessage() {
        this.paymentsubject.next(true);
    }

    getPaymentMessage(): Observable<any> {
        return this.paymentsubject.asObservable();
    }

    sendCartMessage(message: string) {
        this.cartsubject.next( message );
    }

    clearCartMessage() {
        this.cartsubject.next(true);
    }

    getCartMessage(): Observable<any> {
        return this.cartsubject.asObservable();
    }

	sendlocationMessage(locationlist: any) {
        this.locationsubject.next( locationlist );
    }


    clearlocationMessage() {
        this.locationsubject.next(true);
    }

    getlocationMessage(): Observable<any> { 
        
        return this.locationsubject.asObservable();
    }
	
	sendAutocompleteSearchParameterMessage(messageData: any) {
       // console.log('message service');
       // console.log(messageData);
        this.autocompletesubject.next( messageData );
    }

    clearAutocompleteSearchParameterMessage() {
        this.autocompletesubject.next(true);
    }

	getAutocompleteSearchParameterMessage(): Observable<any> {
        //console.log('message servicessss');
        return this.autocompletesubject.asObservable();
    }
	
	sendAuthUserDataMessage(messageData: any) {
        this.authdatasubject.next( messageData );
    }

    clearAuthUserDataMessage() {
        this.authdatasubject.next(true);
    }

	getAuthUserDataMessage(): Observable<any> {
        return this.authdatasubject.asObservable();
    }
	
	sendPhotoVideo(messageData: any) {
        this.addphotovideosubject.next( messageData );
    }

    clearPhotoVideo() {
        this.addphotovideosubject.next(true);
    }

	getPhotoVideo(): Observable<any> {
        return this.addphotovideosubject.asObservable();
    }
	
	
	
	sendExpStatusChangedToMainComponent(messageData: any) {
		//console.log(messageData);
        this.addRegistryPopupToComponentsubject.next( messageData );
    }

    clearExpStatusChangedToMainComponent() {
        this.addRegistryPopupToComponentsubject.next(true);
    }

	getExpStatusChangedToMainComponent(): Observable<any> {
        return this.addRegistryPopupToComponentsubject.asObservable();
    }
	
	sendGiftCertificate(messageData: any) {
		//console.log(messageData);
        this.addgiftcertificate.next( messageData );
    }

    clearGiftCertificate() {
        this.addgiftcertificate.next(true);
    }

	getGiftCertificate(): Observable<any> {
        return this.addgiftcertificate.asObservable();
    }
	
	sendvideo_url(messageData: any) {
        this.video_url.next( messageData );
    }

    clearvideo_url() {
        this.video_url.next(true);
    }

	getvideo_url(): Observable<any> {
        return this.video_url.asObservable();
    }
	sendNotificationCount(messageData: any) {
        this.notification_count.next( messageData );
    }

    clearNotificationCount() {
        this.notification_count.next(true);
    }

	getNotificationCount(): Observable<any> {
        return this.notification_count.asObservable();
    }
	
	sendPhotoUpdateProcess(messageData: any) {
        this.photoUpdateSubject.next( messageData ); 
    }

    clearPhotoUpdateProcess() {
        this.photoUpdateSubject.next(true);
    }

	getPhotoUpdateProcess(): Observable<any> {
        return this.photoUpdateSubject.asObservable();
    }
	
	sendFacebookData(messageData: any) {
        this.facebookDataSubject.next( messageData );
    }
 
    clearFacebookData() {
        this.facebookDataSubject.next(true);
    }

	getFacebookData(): Observable<any> {
        return this.facebookDataSubject.asObservable();
    }
	
	sendCoupleStartTimerMessage(messageData: any) {
        this.coupleStartTimerSubject.next( messageData );
    }

    clearCoupleStartTimerMessage() {
        this.coupleStartTimerSubject.next(true);
    }

	getCoupleStartTimerMessage(): Observable<any> {
        return this.coupleStartTimerSubject.asObservable();
    }

    sendExpStepData(messageData: any) {
        this.createExpStepSubject.next(messageData);
    } 

    clearExpStepData() {
        //this.createExpStepSubject.next(true);
    }

    getExpStepData(): Observable<any> {
        return this.createExpStepSubject.asObservable();
    }

	getTip(): Observable<any> {
        return this.addTip.asObservable();
    }
    
    sendTip(messageData: any) {
		//console.log(messageData);
        this.addTip.next( messageData );
    }

  
}
